export const META_TYPE = 'paperTrader';
export const META_VER = 'v1';

export const CMD_PAPERTRADER_REGISTRY_KEY = `${META_TYPE}:${META_VER}`;
